import axios from 'axios'
import { BASE_URL } from '../constant'

export const registerFleet = async (formData) => {
  try {
    // if (!(formData instanceof FormData)) {
    //   throw new Error('Expected a FormData instance')
    // }
    const response = await axios.post(
      `${BASE_URL}/fleet-owners/register`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'Failed to upload registration form'
    )
  }
}

export const createFleetOwners = async (driverData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/fleet-owners/create-fleet-owner`,
      driverData
    )
    return response.data // This will return the created fleet driver data
  } catch (error) {
    console.error('Error creating fleet driver:', error)
    throw error // Re-throw the error to be handled by the caller
  }
}

// export const createFleetDriver = async (driverData) => {
//   try {
//     const response = await axios.post(`${BASE_URL}/fleet-drivers`, driverData)
//     return response.data // This will return the created fleet driver data
//   } catch (error) {
//     console.error('Error creating fleet driver:', error)
//     throw error // Re-throw the error to be handled by the caller
//   }
// }

export const createFleetCab = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/fleet-cabs/create`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Ensure we send files as form data
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error creating fleet cab:', error)
    throw error
  }
}
export const updateFleetCabAndFiles = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/fleet-cabs/update`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Ensure we send files as form data
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error creating fleet cab:', error)
    throw error
  }
}

export const createFleetDriver = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL}/fleet-drivers`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error creating fleet cab:', error)
    throw error
  }
}
